import React from 'react';
import ReactDOM from 'react-dom';
import ContentTabs from "../../../ContentTabs/components/ContentTabs";

const data = [
    {
        backgroundUrl: "/images/solutions/education/OC_Hub_Edu_770_test.jpg",
        iconUrl: "/images/solutions/oc_hub.svg",
        title: i18njs["Solutions.OptomaCollaborationHub"],
        mainText: i18njs["Solutions.OcHubMainText"],
        buttonText: i18njs["Solutions.MoreInfo"],
        buttonUrl: "/product/och100"
    }
]

ReactDOM.render(
    <ContentTabs data={data}></ContentTabs>,
    document.getElementById("educationOcHub")
);
